import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import AnalisarProjeto from './pages/AnalisarProjeto';
import ResultadosPage from './pages/ResultadosPage';
import HistoricoRelatorios from './pages/HistoricoRelatorios';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">
              🏗️ Aprovador Cascavel v1.0
            </Link>
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">Nova Análise</Link>
              </li>
              <li className="nav-item">
                <Link to="/historico" className="nav-link">Histórico</Link>
              </li>
            </ul>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<AnalisarProjeto />} />
            <Route path="/resultados/:relatorioId" element={<ResultadosPage />} />
            <Route path="/historico" element={<HistoricoRelatorios />} />
          </Routes>
        </main>

        <footer className="footer">
          <p>© 2026 Aprovador Cascavel — Verificador de Compliance Urbanístico</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
